import BX24API from "../bx24";

export const getUserFromBX24 = async () => {
  return await BX24API.callMethod("user.current", {});
};
